import { ITotalCounts } from "../components/LocationStats/Sidebar/LocationLeftSidebar";
import { LocationActionsLog, LocationStats } from "../Models";
import { APIURL, paginationData } from "./config";

export async function GetLocationStats(
  locationFilterQuery: string,
  candidateFilterQuery: string,
  universityFilterQuery: string,
  companyFilterQuery: string,
  sortQuery: string,
  searchQuery: string,
  currentPage: number,
  currentTab: string,
  token: string | undefined,
  univRankTypeId: string,
  compRankTypeId: string,
  atTheTime: number
) {
  const res = await fetch(
    `${APIURL}/Location/LocationStats?filterQuery=${locationFilterQuery}&candidateFilterQuery=${candidateFilterQuery}&universityFilterQuery=${universityFilterQuery}&companyFilterQuery=${companyFilterQuery}&orderBy=${sortQuery}&searchQuery=${searchQuery}&pageNumber=${currentPage}&pageSize=${50}&searchBy=${currentTab}&univRankTypeId=${univRankTypeId}&compRankTypeId=${compRankTypeId}&locationType=${atTheTime}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const locationStats: {
    locations: LocationStats[];
    paginationMetadata: paginationData;
  } = await res.json();

  return locationStats;
}
export async function GetLocationStatsGeoJson(
  locationFilterQuery: string,
  candidateFilterQuery: string,
  universityFilterQuery: string,
  companyFilterQuery: string,
  sortQuery: string,
  searchQuery: string,
  currentPage: number,
  currentTab: string,
  createMapBy: string | undefined,
  token: string | undefined,
  univRankTypeId: string,
  compRankTypeId: string,
  atTheTime: number
) {
  const res = await fetch(
    `${APIURL}/Location/LocationStatsGeoJson?filterQuery=${locationFilterQuery}&candidateFilterQuery=${candidateFilterQuery}&universityFilterQuery=${universityFilterQuery}&companyFilterQuery=${companyFilterQuery}&orderBy=${sortQuery}&searchQuery=${searchQuery}&pageNumber=${currentPage}&pageSize=${30}&searchBy=${currentTab}&createBy=${createMapBy}&univRankTypeId=${univRankTypeId}&compRankTypeId=${compRankTypeId}&locationType=${atTheTime}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch GeoJSON data");
  }

  const geoJsonData = await res.json();

  return geoJsonData;
}
export async function GetSubCities(
  locationFilterQuery: string,
  candidateFilterQuery: string,
  universityFilterQuery: string,
  companyFilterQuery: string,
  sortQuery: string,
  searchQuery: string,
  token: string | undefined,
  univRankTypeId: string,
  compRankTypeId: string,
  atTheTime: number,
  locationId: string
) {
  const res = await fetch(
    `${APIURL}/Location/LocationStats/City?filterQuery=${locationFilterQuery}&candidateFilterQuery=${candidateFilterQuery}&universityFilterQuery=${universityFilterQuery}&companyFilterQuery=${companyFilterQuery}&orderBy=${sortQuery}&searchQuery=${searchQuery}&univRankTypeId=${univRankTypeId}&compRankTypeId=${compRankTypeId}&locationType=${atTheTime}&cityId=${locationId}&searchBy=${"city"}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch sub-cities");
  }

  const subCities: LocationStats[] = await res.json();
  return subCities;
}
export async function MakeSubcity(
  cityIds: string[],
  majorCityId: string,
  token: string | undefined
) {
  const res = await fetch(
    `${APIURL}/Location/makeSubCity?majorCityId=${majorCityId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(cityIds),
    }
  );

  return;
}
export async function MakeMajorCity(
  cityIds: string[],
  token: string | undefined
) {
  const res = await fetch(`${APIURL}/Location/makeMajorCity`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(cityIds),
  });

  return;
}
export async function GetTotalCounts(
  roleIds: string[] | undefined,
  token: string | undefined
) {
  const queryParams = new URLSearchParams();

  if (roleIds) {
    roleIds.forEach((id) => queryParams.append("roleIds", id));
  }

  const res = await fetch(
    `${APIURL}/Location/TotalCounts?${queryParams.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error(`Error fetching total counts: ${res.statusText}`);
  }

  const counts: ITotalCounts = await res.json();
  return counts;
}
export async function fetchLocationActionsLog(token: string | undefined) {
  try {
    const res = await fetch(`${APIURL}/Location/ActionLogs`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error("Failed to fetch action logs");
    }
    const actionLogs: LocationActionsLog[] = await res.json();
    return actionLogs;
  } catch (error) {
    console.error(error);
    return [];
  }
}